import React from "react";
import classNames from "classnames/bind";

import { Telescope } from "src/assets/icons";

import styles from "./FAB.module.scss";
const cx = classNames.bind(styles);

const Fab = ({ handleClick }) => {
  return (
    <div className={cx("fab-root")} onClick={handleClick}>
      <Telescope />
    </div>
  );
};

export default Fab;
